<div class="tw-bg-white tw-pt-4 tw-pb-2" *ngIf="showHeader && !supportView">
  <h1 class="tw-text-400 tw-font-lexend" i18n="@@gotQuestionsNeedHelp">
    <span class="tw-font-bold tw-text-500">Got questions?</span> We are here to help
  </h1>
</div>
<div class="tw-w-full tw-bg-white" [ngClass]="!supportView && !homePageView ? 'tw-pb-4' : ''">
  <div class="tw-w-full tw-rounded-3 tw-overflow-hidden" (click)="openChat()" [ngStyle]="{'background-image':'url(https://cdn.cureskin.com/app/img/llm_chat_bg.png)', 'background-position': 'top right', 'background-size': 'cover'}">
    <ng-container *ngIf="!supportView">
      <div class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-5 tw-relative tw-font-lexend">
        <img src="https://cdn.cureskin.com/app/img/ai-star.svg" alt="">
        <h1 class="tw-text-300 tw-font-medium" i18n="@@cureskinHealthAssistant">Cureskin AI Health Assistant</h1>
      </div>
    </ng-container>
    <div class="tw-pb-4 tw-pt-2 tw-px-3">
      <h1 *ngIf="!homePageView && !noGradientHeader" [ngClass]="supportView ? 'tw-mb-7 tw-mt-2' : 'tw-mb-3'" class="tw-ml-1 tw-text-650 gradient-text font-redHat-B" i18n="@@chatWithUs">Chat with us</h1>
      <h1 *ngIf="!homePageView && noGradientHeader" class="tw-ml-1 tw-text-500 tw-font-lexend tw-font-bold tw-mb-6 tw-mt-2" i18n="@@chatWithUs">Chat with us</h1>
      <h1 *ngIf="homePageView" class="tw-mb-3 tw-ml-1 tw-text-600 gradient-text font-redHat-B" i18n="@@gotQuestionsChatWithUs">Got questions? Chat with us</h1>
      <div class="tw-w-full tw-relative">
        <form (ngSubmit)="handleMessageSend()" class="tw-w-full">
          <div class="tw-w-full tw-flex tw-items-center tw-border tw-border-gray-200 tw-shadow-z9 tw-rounded-3 tw-bg-white">
            <div class="tw-relative tw-w-full">
              <input #msgInput
                     (focus)="onInputFocus()"
                     (blur)="onInputBlur()"
                     [(ngModel)]="inputValue"
                     class="tw-py-3 tw-pl-3 tw-pr-2 tw-rounded-2xl tw-w-full"
                     type="text"
                     name="message"
                     [disabled]="true"
                     autocomplete="off" />
              <ng-container *ngIf="!msgInput.value.trim()">
                <div class="tw-w-fit tw-absolute tw-text-gray-400 tw-z-[1] tw-inset-0 tw-p-3 tw-flex tw-gap-1 tw-items-center tw-pointer-events-none tw-text-300 tw-font-lexend tw-font-normal">
                  <div class="tw-overflow-hidden tw-h-6">
                    <div class="tw-animate-slideWords tw-flex tw-flex-col">
                      <ng-container *ngFor="let w of scrollingWords">
                        <div class="tw-h-6 tw-select-none tw-mt-0.5">{{ w }}</div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div
              class="tw-w-fit tw-p-1.5 tw-mr-3 tw-rounded-full tw-cursor-pointer"
              [ngClass]="{'tw-bg-gray-300': !msgInput.value.trim(), 'tw-bg-teal-600': msgInput.value.trim()}"
              (click)="$event.preventDefault(); handleMessageSend()"
              (touchstart)="$event.preventDefault(); $event.stopPropagation(); handleMessageSend()">
              <img src="/assets/chat-send.svg" class="tw-w-6" alt="send" />
            </div>
          </div>
        </form>
        <div class="tw-absolute tw-inset-0"></div>
      </div>
    </div>
  </div>
</div>
